import { isMobile } from '~/utils';

export const isHeaderVisible = (ismobile) => isMobile(ismobile);

export const isButtonVisible = (ismobile) => !isMobile(ismobile);
